import { render } from "./PlansSuscriptionModal.vue?vue&type=template&id=67fd4b31"
import script from "./PlansSuscriptionModal.vue?vue&type=script&lang=js"
export * from "./PlansSuscriptionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__